import { useTranslation } from 'react-i18next';
import { FieldValues } from 'react-hook-form';
import { TextFieldProps } from '@mui/material/TextField';

import { IOfferTypeChoices } from 'graphql/types';
import { SelectField } from 'common/forms/Field';
import { TControllerProps } from 'common/types';

interface IProps extends Omit<TextFieldProps, 'name'> {
    name: string;
}

export const OfferTypeSelectField = <TFieldValues extends FieldValues>({
    ...other
}: IProps & TControllerProps<TFieldValues>) => {
    const [translate] = useTranslation();

    const offerTypeOptions = [
        {
            value: IOfferTypeChoices.Training,
            label: translate('offer.offerTypeSelect.training'),
        },
        {
            value: IOfferTypeChoices.Course,
            label: translate('offer.offerTypeSelect.course'),
        },
    ];

    return <SelectField {...other} options={offerTypeOptions} />;
};
